module.exports = __webpack_public_path__ + "1.5.0-unryo/img/nutanix.31e6a130.svg";